import { render, staticRenderFns } from "./EditarPerfil.vue?vue&type=template&id=51564cda"
import script from "./EditarPerfil.vue?vue&type=script&lang=js"
export * from "./EditarPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports